import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Navbar.css';

function NavIcon({ type }) {
  if (type === 'ranking') {
    return (
      <svg viewBox="0 0 576 512" aria-hidden="true">
        <path d="M552 64H448V24c0-13.3-10.7-24-24-24H152c-13.3 0-24 10.7-24 24v40H24C10.7 64 0 74.7 0 88v56c0 70.7 57.3 128 128 128h8c11.4 45.3 41.2 84.3 80 107.9V448H136c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h304c13.3 0 24-10.7 24-24v-16c0-13.3-10.7-24-24-24h-80v-68.1c38.8-23.6 68.6-62.6 80-107.9h8c70.7 0 128-57.3 128-128V88c0-13.3-10.7-24-24-24zM64 144v-32h64v96c0 5.4.4 10.7 1 16h-1c-35.3 0-64-28.7-64-64zm448 0c0 35.3-28.7 64-64 64h-1c.6-5.3 1-10.6 1-16v-96h64v32z" />
      </svg>
    );
  }
  if (type === 'price') {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M3 7.5 12 3l9 4.5-9 4.5L3 7.5Zm2 3.1 6 3v7l-6-3v-7Zm8 10v-7l6-3v7l-6 3Z" />
      </svg>
    );
  }
  if (type === 'apartment') {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M3 21h18v-2H3v2Zm2-3h5V5H5v13Zm7 0h7V3h-7v15ZM7 7h1v1H7V7Zm0 3h1v1H7v-1Zm0 3h1v1H7v-1Zm2-6h1v1H9V7Zm0 3h1v1H9v-1Zm0 3h1v1H9v-1Zm5-8h1v1h-1V5Zm0 3h1v1h-1V8Zm0 3h1v1h-1v-1Zm0 3h1v1h-1v-1Zm2-9h1v1h-1V5Zm0 3h1v1h-1V8Zm0 3h1v1h-1v-1Zm0 3h1v1h-1v-1Z" />
      </svg>
    );
  }
  if (type === 'home') {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M4 11.2 12 4l8 7.2V20h-5.3v-5.5H9.3V20H4v-8.8Z" />
      </svg>
    );
  }
  if (type === 'compare') {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M10 3H5.5A1.5 1.5 0 0 0 4 4.5v15A1.5 1.5 0 0 0 5.5 21H10V3Zm10 0h-4.5v18H20a1.5 1.5 0 0 0 1.5-1.5v-15A1.5 1.5 0 0 0 20 3Z" />
      </svg>
    );
  }
  if (type === 'favorite') {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 21s-7.1-4.4-9.6-8.1C-0.1 9.3 1.1 4.7 5 3.2c2.4-.9 4.9-.2 7 2 2.1-2.2 4.6-2.9 7-2 3.9 1.5 5.1 6.1 2.6 9.7C19.1 16.6 12 21 12 21Z" />
      </svg>
    );
  }
  if (type === 'logout') {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M11 3h2v10h-2V3Zm-5.7 2.3 1.4 1.4A7 7 0 1 0 17.3 6.7l1.4-1.4A9 9 0 1 1 5.3 5.3Z" />
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 12a5 5 0 1 0-5-5 5 5 0 0 0 5 5Zm0 2c-4.4 0-8 2.2-8 5v1h16v-1c0-2.8-3.6-5-8-5Z" />
    </svg>
  );
}

function Navbar({ isLoggedIn, onLogout }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();

  const isActive = (paths) => {
    const list = Array.isArray(paths) ? paths : [paths];
    return list.some((path) => location.pathname === path || location.pathname.startsWith(`${path}/`));
  };

  const handleLogout = () => {
    if (onLogout) {
      onLogout();
    }
    navigate('/login');
  };

  const showInvestmentHint = isLoggedIn && !user?.hasInvestmentMeta;

  return (
    <nav className="navbar">
      {isLoggedIn && (
        <div className="navbar-user-welcome navbar-user-welcome-fixed" title={`${user?.userName || user?.userId || '사용자'} 님`}>
          <strong>환영합니다 {user?.userName || user?.userId || '사용자'}님</strong>
          <span>아이디 : {user?.userId || '-'}</span>
        </div>
      )}
      <div className="navbar-container">
        <div className="navbar-left-group">
          <Link to="/home" className="navbar-logo">
            <img src="/logo.png" alt="RANKER" className="logo-icon" />
          </Link>
        </div>

        <div className="navbar-menu">
          <Link to="/ranking" className={`navbar-item ${isActive('/ranking') ? 'active' : ''}`}>
            <span className="nav-icon"><NavIcon type="ranking" /></span>
            랭커(단지)
          </Link>

          <Link to="/compare" className={`navbar-item ${isActive('/compare') ? 'active' : ''}`}>
            <span className="nav-icon"><NavIcon type="compare" /></span>
            지역분석(비교)
          </Link>



          {isLoggedIn && (
            <Link to="/favorites" className={`navbar-item ${isActive('/favorites') ? 'active' : ''}`}>
              <span className="nav-icon"><NavIcon type="favorite" /></span>
              즐겨찾기
            </Link>
          )}
          <Link to="/pricing" className={`navbar-item ${isActive('/pricing') ? 'active' : ''}`}>
            <span className="nav-icon"><NavIcon type="price" /></span>
            상품소개
          </Link>

          <Link to="/customer-service" className={`navbar-item ${isActive('/customer-service') ? 'active' : ''}`}>
            고객센터
          </Link>

          {isLoggedIn ? (
            <div className="navbar-right-group">
              <span className="navbar-divider" aria-hidden="true" />
              <Link
                to={showInvestmentHint ? '/mypage?tab=investment' : '/mypage'}
                aria-label="마이페이지"
                title="마이페이지"
                className={`navbar-item icon-only ${isActive('/mypage') ? 'active' : ''} ${showInvestmentHint ? 'has-hint' : ''}`}
              >
                <span className="nav-icon"><NavIcon type="user" /></span>
                {/* {showInvestmentHint && (
                  <span className="navbar-hint-bubble" role="status" aria-live="polite">
                    투자 정보를 설정해보세요
                  </span>
                )} */}
              </Link>
              {user?.isAdmin && (
                <Link to="/admin" className={`navbar-item ${isActive('/admin') ? 'active' : ''}`}>관리자</Link>
              )}
              <button
                onClick={handleLogout}
                className="navbar-item icon-only navbar-button"
                aria-label="로그아웃"
                title="로그아웃"
              >
                <span className="nav-icon"><NavIcon type="logout" /></span>
              </button>
            </div>
          ) : (
            <Link to="/login" className="navbar-item navbar-login">로그인</Link>
          )}
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
